import React, { useState } from "react";
import PropTypes from "prop-types";

const UrlUpload = ({ uploading, onUpload }) => {
  const [urlInput, setUrlInput] = useState("");

  const handleSubmit = () => {
    onUpload(urlInput, () => setUrlInput(""));
  };

  return (
    <div className="km-url-section">
      <input
        type="url"
        className="km-input"
        placeholder="https://example.com/docs"
        value={urlInput}
        onChange={(e) => setUrlInput(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && !uploading && handleSubmit()}
        disabled={uploading}
      />
      <button
        className="km-btn km-btn-primary"
        onClick={handleSubmit}
        disabled={uploading || !urlInput.trim()}
      >
        {uploading ? "Adding..." : "Add URL"}
      </button>
    </div>
  );
};

UrlUpload.propTypes = {
  uploading: PropTypes.bool,
  onUpload: PropTypes.func.isRequired,
};

export default UrlUpload;
